<template>
  <div class="wrap">
    <div class="top_bg_wrap">
      <div class="main_visual">
        <div class="sub_top">
          <div class="v_content">
            <div class="subtop_right_pic">
              <img src="static/seoul/img/subtop_right_pic.png" alt="">
            </div>
            <div class="subtop_left_copy">
              <span class="s_title">&nbsp;</span>
              <p><span class="b_title">영상회의실 예약</span></p>
            </div>
            <!-- // -->
          </div>
        </div>
        <!--//.sub_top  -->
      </div>
      <!-- //.top_bg_wrap -->
      <div class="sub_wrap">
        <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <!-- <schedule-filter :isAddAll="false" :groupChange="groupChange" :buildingChange="buildingChange" :changedGroupId="changedGroupId" :type="'video'"/> -->
      <v-flex lg12 sm12 xs12 style="padding-bottom:0; margin-top: 15px;">
        <div class="status-wrap" v-for="type in eventTypes" :key="type.key">
          <div class="status-color" :style="{ backgroundColor: type.color }"></div>
          <div class="status-title">{{ type.text }}</div>
        </div>
      </v-flex>

      <v-flex lg12 sm12 xs12>
        <ejs-schedule id="schedule" ref="scheduleObj" :cssClass="customClass" width="100%" :selectedDate="selectedDate"
          :currentView="currentView" :timeScale="timeScale" :workHours="workHours" :eventSettings="eventSettings"
          :group="group" :cellClick="onCellClick" :popupOpen="onPopupOpen"
          :eventClick="onEventClick" :resourceHeaderTemplate="resourceHeaderTemplateTimeline" :renderCell="onRenderCell" :eventRendered="onEventRendered"
          :quickInfoTemplates="quickInfoTemplates" :cellDoubleClick="onCellDoubleClick"
          :showTimeIndicator="false" :rowAutoHeight="true" :startHour="startHour" :endHour="endHour"
          :actionComplete="onActionComplete" :workDays="workDays" :locale="locale"
        >
          <e-views>
            <e-view option="TimelineDay"/>
            <!-- <e-view option="TimelineWeek" :timeScale="weekTimeScale"></e-view> -->
          </e-views>
          <e-resources>
            <e-resource ref="resourceObj" field="roomIds" title="Room Type" name="MeetingRoom"
              allowMultiple="false" :dataSource="meetingRoomDataSource"
              textField="name" idField="_id">
            </e-resource>
          </e-resources>
        </ejs-schedule>
      </v-flex>
      <v-flex lg12 sm12 xs12 v-if="isPaging">
        <div class="text-xs-center">
          <v-pagination
            v-model="pagination.selectedPage"
            :length="pagination.length"
            :total-visible="10"
            circle
            class="v-page-btn"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

  </v-container>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import { mapState } from 'vuex';
import { extend, isNullOrUndefined, L10n, loadCldr, Internationalization } from '@syncfusion/ej2-base';
import { TimelineViews, TimelineMonth, Resize, DragAndDrop, Agenda, Timezone } from '@syncfusion/ej2-vue-schedule';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import Util from '@/util';
import ScheduleFilter from '@/components/schedules/Filter';
import MeetingCustomAdapter from '@/components/schedules/MeetingCustomAdapter';
import * as localeText from '@/components/schedules/locale/locale.json';
import * as gregorian from '@/components/schedules/locale/ca-gregorian.json';
import * as numbers from '@/components/schedules/locale/numbers.json';
import * as timeZoneNames from '@/components/schedules/locale/timeZoneNames.json';

L10n.load(localeText);
loadCldr(gregorian, numbers, timeZoneNames);

// Array.prototype.forEach = function (callback, thisArg) {
//   thisArg = thisArg || window;
//   for (let i = 0; i < this.length; i++) {
//     callback.call(thisArg, this[i], i, this);
//   }
// };

const resourceHeaderTimeline = Vue.component('resourceHeader', {
  data () {
    return {
      data: {}
    };
  },
  template: `
    <div class="template-wrap">
      <div style="flex: 0 0 70% !important; -ms-flex: 0 0 70% !important; font-weight: bold !important; font-size: 14px;">
        <span class="room-name" style="margin-left: 5px;">{{data.resourceData.name}}</span>
      </div>
      <div class="room-type" style="flex: 0 0 30% !important; -ms-flex: 0 0 30% !important; text-align: center;">
        <div style="margin: 0 auto;">
          {{data.resourceData.capacity}}명
          <v-icon small color="pink" v-if="data.resourceData.isApprove">mdi-check-circle</v-icon>
          <v-icon small color="green" v-else>mdi-minus-circle</v-icon>
        </div>
      </div>
    </div>
  `
});

let resourceHeaderWeekMonth = Vue.component('resource-template', {
  data () {
    return {
      data: {}
    };
  },
  template: `
    <div class="template-wrap">
      <div class="room-image">
        <v-icon v-if="data.resourceData.type === 'video'" color="pink">mdi-desktop-mac</v-icon>
        <v-icon v-else color="green">mdi-door-open</v-icon>
      </div>
      <div class="room-details">
        <div class="room-name">{{data.resourceData.name}}</div>
        <div class="room-model">Floor: {{data.resourceData.floor}}</div>
        <div class="room-seats">Capacity: {{data.resourceData.capacity}}</div>
      </div>
    </div>`
});

const headerTemplateVue = Vue.component('headerTempate', {
  data () {
    return {
      data: {
        router: this.$router
      }
    };
  },
  methods: {
    eventEdit () {
      let data = this.data;
      if (moment() >= moment(data.startDtime)) {
        Util.snackBarOpen(this.$t('page.schedules.msg.not-modify'), 'pink');
        return;
      }
      this.$router.push({ name: 'Reserve', query: { meetingId: data._id }});
      return;
    }
  },
  template: `
    <v-container fluid grid-list-xl :style="{ background: data.status === 'e' ? '#8C8C8C' : data.color}">
      <v-layout row wrap justify-center align-center>
        <v-flex class="calendar-detail-flex">
          <span class="calendar-detail-span" style="color: white;">{{data.title ? data.title : 'No Title' }}</span>
        </v-flex>
        <v-spacer/>
        <v-icon style="margin-top: 5px; margin-right: 5px;" flat small dark @click="eventEdit" :disabled="data.isReadOnly || data.status !== 'r'">edit</v-icon>
        <button style="color: white;" class="e-delete" :disabled="data.isReadOnly" title="DELETE"></button>
        <button style="color: white;" class="e-close" title="CLOSE"></button>
      </v-layout>
    </v-container>
  `
});

const contentTemplateVue = Vue.component('contentTemplate', {
  data () {
    return {
      data: {}
    };
  },
  template: `
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center align-center>
        <v-flex class="calendar-detail-flex" xs12 v-if="data.startDtime !== undefined">
          <v-icon color="gray">mdi-alpha-s-box</v-icon>&nbsp;
          <span class="calendar-detail-span">{{data.startDtime | formatDate}}</span>
        </v-flex>
        <v-flex class="calendar-detail-flex" xs12 v-if="data.endDtime !== undefined">
          <v-icon color="gray">mdi-alpha-e-box</v-icon>&nbsp;
          <span class="calendar-detail-span">{{data.endDtime | formatDate}}</span>
        </v-flex>
        <v-flex class="calendar-detail-flex" xs12 v-if="data.creator !== undefined">
          <v-icon color="gray">person</v-icon>&nbsp;
          <span class="calendar-detail-span">{{data.creator.displayFullName ? data.creator.displayFullName : data.creator.username}}</span>
        </v-flex>
        <v-flex class="calendar-detail-flex" xs12 v-if="data.attendees !== undefined">
          <div v-if="data.attendees.length > 1">
            <v-icon color="gray">people</v-icon>&nbsp;
            <span class="calendar-detail-span">Participants List ({{ data.attendees.length }})</span>
            <div
              class="calendar-detail-span"
              v-html="data.attendeesList"
              style="max-height: 100px; overflow: auto; border: solid 1px; padding: 5px 5px 5px 5px; font-size: 13px !important;">
            </div>
          </div>
          <div v-else>
            <v-icon color="gray">people</v-icon>&nbsp;
            <span class="calendar-detail-span">{{data.attendeesList}}</span>
          </div>
        </v-flex>
        <v-flex class="calendar-detail-flex" xs12 v-if="data.type !== undefined">
          <v-icon color="gray">mdi-google-classroom</v-icon>&nbsp;
          <span class="calendar-detail-span">{{data.type.charAt(0).toUpperCase() + data.type.slice(1)}}</span>
        </v-flex>
      </v-layout>
    </v-container>`
});

const headerTooltipTemplateVue = Vue.component('headerTooltipTemplate', {
  data () {
    return {
      data: {}
    };
  },
  template: `
    <div class='template-wrap' style="padding: 5px;">
      <div class="resource-text" style="font-size: 15px; padding-bottom: 5px;">
        Building : {{data.resourceData.buildingName}}
      </div>
      <div class="resource-text" style="font-size: 15px; padding-bottom: 5px;">
        Name : {{data.resourceData.name}}
      </div>
      <div class="resource-text" style="font-size: 15px; padding-bottom: 5px;">
        Type : {{data.resourceData.type.charAt(0).toUpperCase() + data.resourceData.type.slice(1)}}
      </div>
      <div class="resource-text" style="font-size: 15px; padding-bottom: 5px;" v-if="data.resourceData.type === 'video'">
        IP : {{data.resourceData.deviceInfo.length > 0 ? data.resourceData.deviceInfo[0].ip : 'None setting' }}
      </div>
      <div class="resource-text" style="font-size: 15px;">
        {{data.resourceData.isApprove === true ? '승인이 필요한 부대시설' : ''}}
      </div>
    </div>`
});

let instance = new Internationalization();
const majorTemplateVue = Vue.component('majorSlotTemplate', {
  data () {
    return {
      data: {}
    };
  },
  methods: {
    majorSlotTemplate: function (date) {
      return instance.formatDate(date, { skeleton: 'Hm' });
    }
  },
  template: '<div>{{majorSlotTemplate(data.date)}}</div>',
});

export default {
  name: 'Calendar',
  components: {
    ScheduleFilter,
  },
  data: function () {
    return {
      locale: 'ko',
      startHour: '06:00',
      endHour: '24:00',
      // quickInfo: {
      //   clickedEventInfo: undefined,
      //   clickedEventQuickInfoStyle: {
      //     position: 'absolute',
      //     left: '0px',
      //     top: '0px',
      //     width: '300px'
      //   },
      // },
      warning: {
        dialog: false,
        errorMsg: null
      },
      infoDialog: {
        title: '',
        content: '',
        subContents: [],
        dialog: false,
        type: 'reserveCheck'
      },
      meetings: [],
      workDays: [0, 1, 2, 3, 4, 5, 6],
      eventSettings: {
        dataSource: [],
        // dataSource: this.getMeetings(),
        fields: {
          id: '_id',
          subject: { title: '회의명', name: 'title' },
          location: { title: '위치', name: 'location' },
          description: { title: '회의설명', name: 'description' },
          startTime: { title: '회의시작', name: 'startDtime' },
          endTime: { title: '회의종료', name: 'endDtime' },
          recurrenceRule: { title: '반복', name: 'recurrenceRule' },
          categoryColor: { title: 'Color', name: 'categoryColor' }
        }
      },
      selectedDate: new Date(),
      currentView: 'TimelineDay',
      workHours: {
        start: this.$store.state.settings.meetings.workStartHour || '07:00',
        end: this.$store.state.settings.meetings.workEndHour || '18:00'
      },
      timeScale: {
        interval: this.$store.state.settings.meetings.calendarInterval,
        slotCount: this.$store.state.settings.meetings.calendarSlotCnt,
        majorSlotTemplate: function (e) {
          return {
            template: majorTemplateVue
          };
        }
      },
      weekTimeScale: {
        enable: false
      },
      resourceHeaderTemplateTimeline: function (e) {
        return {
          template: resourceHeaderTimeline
        };
      },
      resourceHeaderTemplateWeekMonth: function (e) {
        return {
          template: resourceHeaderWeekMonth
        };
      },
      quickInfoTemplates: {
        // header: function (e) {
        //   return {
        //     template: headerTemplateVue
        //   };
        // },
        content: function (e) {
          return {
            template: contentTemplateVue
          };
        }
      },
      allowMultiple: false,
      group: {
        allowGroupEdit: true,
        enableCompactView: false,
        resources: ['MeetingRoom'],
        headerTooltipTemplate: (e) => {
          return {
            template: headerTooltipTemplateVue
          };
        }
      },
      pagination: {
        limit: 14,
        length: 0,
        selectedPage: 1,
        skip: 0
      },
      // meetingRoomDataSource: this.getMeetingRooms(1, 0, this.$store.state.user.company, this.$store.state.user.location),
      meetingRoomDataSource: [],
      filter: {
        gropuId: '9999',
        buildingId: '9999',
        floor: '9999'
      },
      selectedMeeting: undefined,
      roomDetail: {
        selectedRoom: undefined,
        dialog: false
      },
      rooms: [],
      viewMode: 'day',
      viewModeList: [
        { key: 'day', text: 'Day' },
        { key: 'week', text: 'Week' },
        { key: 'month', text: 'Month' }
      ],
      customClass: 'room-scheduler',
      isFirstDataBinding: true,
      /**
       * initPopup 개발
       */
      isNotInfo: false,
      error: null,
      rules: {
        required: (value) => Util.validationRequired(value),
      },
      info: {
        company: undefined,
        location: undefined,
        floor: undefined
      },
      companies: [],
      locations: [],
      locationsList: [],
      changedGroupId: '',
      isPaging: true,
      isUseDataManager: false,
      changeFlag: false,
      approveCheckParams: null,
      eventTypes: [
        { key: 'me', color: '#005a9e', text: '나의예약' },     // creator.email === 나
        { key: 'meQ', color: '#8cbd18', text: '나의승인' },     // creator.email === 나 이고 q 인거
        { key: 'r', color: '#ed616f', text: '예약완료' },       // status === 'r'
        { key: 'q', color: '#ffb900', text: '승인대기' },   // status === 'q'
        { key: 'e', color: '#393939', text: '이용종료' },    // status === 'e'
      ]
    };
  },
  computed: {
    ...mapState([
      'isUserLoggedIn'
    ]),
    computePageHeaderIcon () {
      return '/static/page_header.png';
    }
  },
  watch: {
    '$store.state.locale': {
      handler (val) {
        console.log(val);
        this.locale = val === 'kr' ? 'ko' : val;
        this.$refs.scheduleObj.changeDate(new Date());
      }
    },
    'pagination.selectedPage': {
      handler (val) {
        this.getPagingRooms();
      }
    }
  },
  created () {
    document.addEventListener('mouseup', this.mouseupHandler);
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.mouseupHandler);
  },
  async mounted () {
    let result = await Util.hasSession(this);
    if (!result) return;
    this.companies = (await this.$http.get('/api/v1/company/groups', { params: { isUseRoomMeeting: true }})).data;
    this.locationsList = (await this.$http.get('/api/v1/building', { params: { isUseRoomMeeting: true }})).data;
    this.info.company = this.$store.state.user.company ? this.$store.state.user.company : undefined;
    this.changeCompany(this.info.company);
    if (this.info.company && this.info.location) {
      this.isNotInfo = false;
    } else {
      console.log(this.info);
      this.isNotInfo = true;
      return;
    }
    await this.getRooms(this.$store.state.user.company, this.$store.state.user.location, this.$store.state.user.floor ? this.$store.state.user.floor : '9999', this.pagination.limit, this.pagination.skip);
  },
  async activated () {
    let result = await Util.hasSession(this);
    if (!result) return;

    this.pagination.selectedPage = 1;
    this.workHours = {
      start: this.$store.state.settings.meetings.workStartHour || '07:00',
      end: this.$store.state.settings.meetings.workEndHour || '18:00'
    };
    await this.getRooms(this.$store.state.user.company, this.$store.state.user.location, this.$store.state.user.floor ? this.$store.state.user.floor : '9999', this.pagination.limit, this.pagination.skip);
    this.clearSelectedCells();
    document.addEventListener('mouseup', this.mouseupHandler);
  },
  deactivated () {
    document.removeEventListener('mouseup', this.mouseupHandler);
  },
  provide: {
    schedule: [TimelineViews, TimelineMonth]
  },
  methods: {
    changeCompany (groupId) {
      this.locations = this.locationsList.filter(x => x.groupId._id === groupId);
      this.info.location = this.$store.state.user.location ? this.$store.state.user.location : undefined;
      if (this.info.location) {
        let index = this.locations.findIndex(x => x._id === this.info.location);
        if (index < 0) {
          this.info.location = undefined;
          this.info.floor = undefined;
        } else {
          this.info.floor = this.$store.state.user.floor ? this.$store.state.user.floor : undefined;
        }
      }
    },
    getRooms: function (groupId, buildingId, floor, limit, skip) {
      console.log(groupId);
      console.log(buildingId);
      console.log(floor);
      let url = '';
      // let query = `?limit=${limit}&skip=${skip}`;
      if (groupId) {
        if (buildingId) {
          url = `/api/v1/rooms/${groupId}/${buildingId}/${floor === '9999' ? '' : floor}`;
        } else {
          url = `/api/v1/rooms/${groupId}`;
        }
      } else {
        url = `/api/v1/rooms/-1`;
      }
      // video Room만 출력
      url += `?type=video`;
      this.$http.get(url).then(res => {
        this.rooms = res.data;
        this.getPagingRooms(true);
      }).catch(err => {
        console.log(err);
      });
    },
    getPagingRooms: function (isRefresh) {
      this.pagination.length = (this.rooms.length % this.pagination.limit > 0)
        ? Math.floor(this.rooms.length / this.pagination.limit) + 1
        : Math.floor(this.rooms.length / this.pagination.limit);
      this.pagination.skip = (this.pagination.selectedPage - 1) * this.pagination.limit;
      console.log(this.rooms);
      this.meetingRoomDataSource = this.rooms.slice(this.pagination.skip, this.pagination.limit * this.pagination.selectedPage);
      if (isRefresh) {
        this.refreshMeetings();
      }
    },
    mouseupHandler: async function (e) {
      if (e.target.innerHTML !== '' && e.target.classList[0] === 'room-name') {
        let roomName = e.target.innerHTML.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&');
        let index = this.rooms.findIndex(room => room.name === roomName);
        if (index > -1) {
          this.roomDetail.selectedRoom = this.rooms[index];
          this.roomDetail.dialog = true;
        }
        return;
      }

      let scheduleObj = this.$refs.scheduleObj;
      let target = e.target.classList.contains('e-work-cells');
      let selectedCells = scheduleObj.ej2Instances.element.querySelectorAll('.e-selected-cell');
      if (selectedCells.length > 1 && target) {
        let activeCellsData = scheduleObj.getCellDetails(
          scheduleObj.getSelectedElements()
        );
        let room = scheduleObj.ej2Instances.resources[0].dataSource[activeCellsData.groupIndex];

        if (room.isApprove) {
          this.approveCheckParams = null;
          this.infoDialog.title = '회의실/부대공간예약 안내';
          this.infoDialog.content = '이 회의실은 예약 후 관리자의 승인이 있어야 하므로 예약 결과 반드시 확인 바랍니다. (승인 결과 메일로 통보됨)';
          this.infoDialog.type = 'approveCheck';
          this.infoDialog.dialog = true;
        }

        let departmentChecker = Util.roomDepartmentCheck(room, this.$store.state.user.orgUnitId, this.$store.state.user.workOrgUnitId, this.$store.state.user.email);
        let managerChecker = Util.roomManageCheck(room, this.$store.state.user.email);

        if (managerChecker === true && departmentChecker !== false) {
          this.infoDialog.title = this.$t('page.schedules.reserve-manager-info');
          this.infoDialog.content = this.$t('page.schedules.msg.reserve-manager-info');
          let subContents = [];
          let reservedManagerInfos = (await this.$http.get('/api/v1/organizations', {
            params: { emails: [room.reserveManagerEmail.email] }
          })).data;

          const mData = reservedManagerInfos.filter(m => m.email === room.reserveManagerEmail.email);
          subContents.push({
            roomName: room.name,
            name: room.reserveManagerEmail.name ? room.reserveManagerEmail.name : room.reserveManagerEmail.username,
            // mobile: mData.length >= 1 ? `${mData[0].department}` : ``
            // room.reserveManagerEmail.mobile ? room.reserveManagerEmail.mobile : (room.reserveManagerEmail.email ? room.reserveManagerEmail.email : room.reserveManagerEmail)
          });

          this.infoDialog.subContents = subContents;
          this.infoDialog.dialog = true;
          return;
        } else if (departmentChecker === true && managerChecker !== false) {
          this.infoDialog.title = this.$t('page.schedules.reserve-manager-info');
          this.infoDialog.content = this.$t('page.schedules.msg.reserve-dept-info');
          let subContents = [];
          // 양차장님 요청으로 회의실 정보 나오는 부분 삭제
          // subContents.push({
          //   roomName: room.name,
          //   name: room.reserveDepartment.deptName ? room.reserveDepartment.deptName : '',
          //   isDept: true,
          // });
          this.infoDialog.subContents = subContents;
          this.infoDialog.dialog = true;
          return;
        }

        let params = {
          startDtime: activeCellsData.startTime,
          endDtime: activeCellsData.endTime,
          roomIds: [],
          roomType: 'video', // room.type,
          // roomType: 'room', // room.type,
          timeZone: moment.tz.guess()
        };
        // console.log(`room`, room);
        // return;
        params.roomIds.push(room._id);
        let startDtime = activeCellsData.startTime;
        if (startDtime <= new Date()) {
          let endDtime = activeCellsData.endTime;
          if (endDtime <= new Date()) {
            Util.snackBarOpen(this.$t('page.schedules.msg.overtime'), 'pink');
            return;
          }
          let interval = this.$store.state.settings.meetings.calendarInterval / this.$store.state.settings.meetings.calendarSlotCnt;
          params.startDtime = Util.nearestFutureMinutes(interval, moment());
        }
        if (!scheduleObj.isSlotAvailable(activeCellsData.startTime, activeCellsData.endTime, activeCellsData.groupIndex)) {
          Util.snackBarOpen(this.$t('page.schedules.msg.reserved'), 'pink');
          return;
        }
        if (room.isApprove) {
          this.approveCheckParams = params;
        } else {
          this.$router.push({ name: 'Reserve', query: { meetingInfo: JSON.stringify(params) }});
        }
      }
    },
    getMeetingRooms (limit, skip, groupId, buildingId, floor) {
      let url;
      let query = '';
      // query = `?limit=${limit}&skip=${skip}`;
      if (groupId) {
        if (buildingId) {
          if (floor) {
            url = `/api/v1/rooms/${groupId}/${buildingId}/${floor}${query}`;
          } else {
            url = `/api/v1/rooms/${groupId}/${buildingId}${query}`;
          }
        } else {
          url = `/api/v1/rooms/${groupId}/${query}`;
        }
      } else {
        url = `/api/v1/rooms${query}`;
      }
      return new DataManager({
        url: url
      });
    },
    async getMeetings (startDate, endDate, buildingId) {
      if (this.isUseDataManager) {
        return new DataManager({
          url: `/api/v1/meetings/calendar?type=room`,
          adaptor: new MeetingCustomAdapter()
        });
      } else {
        let params = {
          startDate: startDate,
          endDate: endDate,
          // type: 'room',
          isRecurrence: true,
        };
        if (buildingId !== '9999') {
          params['buildingId'] = buildingId;
        }
        let meetings = (await this.$http.get('/api/v1/meetings/calendar', {
          params: params
        })).data;
        meetings.forEach(function (item) {
          item['roomInfo'] = item['roomIds'][0]; 
          item['roomIds'] = item['roomIds'].map(elem => elem._id);
          item['startDtime'] = new Date(item['startDtime']);
          item['endDtime'] = new Date(item['endDtime']);
          item['attendeesList'] = item['attendees'].length < 1 ? 'No participants' : item['attendees'].map(e => {
            return e.displayFullName ? e.displayFullName : e.username;
          }).join('<br/>');
          if (item.repeatInfo) {
            item['recurrenceRule'] = item.repeatInfo.ruleOutput;
          }
        });
        let scheduleObj = document.getElementById('schedule');
        if (scheduleObj === undefined || scheduleObj === null) return;
        let schObj = scheduleObj.ej2_instances[0];
        schObj.eventSettings.dataSource = meetings;
      }
    },
    isReadOnly: function (endDate) {
      return (endDate < Date.now());
    },
    onCellClick: async function (args) {
      args.cancel = true;
      let scheduleObj = this.$refs.scheduleObj;
      let room = scheduleObj.ej2Instances.resources[0].dataSource[args.groupIndex];

      if (room.isApprove) {
        this.approveCheckParams = null;
        this.infoDialog.title = '회의실/부대공간예약 안내';
        this.infoDialog.content = '이 회의실은 예약 후 관리자의 승인이 있어야 하므로 예약 결과 반드시 확인 바랍니다. (승인 결과 메일로 통보됨)';
        this.infoDialog.type = 'approveCheck';
        this.infoDialog.dialog = true;
      }

      let departmentChecker = Util.roomDepartmentCheck(room, this.$store.state.user.orgUnitId, this.$store.state.user.workOrgUnitId, this.$store.state.user.email);
      let managerChecker = Util.roomManageCheck(room, this.$store.state.user.email);

      if (managerChecker === true && departmentChecker !== false) {
        this.infoDialog.title = this.$t('page.schedules.reserve-manager-info');
        this.infoDialog.content = this.$t('page.schedules.msg.reserve-manager-info');
        let subContents = [];
        let reservedManagerInfos = (await this.$http.get('/api/v1/organizations', {
          params: { emails: [room.reserveManagerEmail.email] }
        })).data;

        const mData = reservedManagerInfos.filter(m => m.email === room.reserveManagerEmail.email);
        subContents.push({
          roomName: room.name,
          name: room.reserveManagerEmail.name ? room.reserveManagerEmail.name : room.reserveManagerEmail.username,
          // mobile: mData.length >= 1 ? `${mData[0].department}` : ``
          // room.reserveManagerEmail.mobile ? room.reserveManagerEmail.mobile : (room.reserveManagerEmail.email ? room.reserveManagerEmail.email : room.reserveManagerEmail)
        });

        this.infoDialog.subContents = subContents;
        this.infoDialog.dialog = true;
        return;
      } else if (departmentChecker === true && managerChecker !== false) {
        this.infoDialog.title = this.$t('page.schedules.reserve-manager-info');
        this.infoDialog.content = this.$t('page.schedules.msg.reserve-dept-info');
        let subContents = [];
        // 양차장님 요청으로 회의실 정보 나오는 부분 삭제
        // subContents.push({
        //   roomName: room.name,
        //   name: room.reserveDepartment.deptName ? room.reserveDepartment.deptName : '',
        //   isDept: true,
        // });
        this.infoDialog.subContents = subContents;
        this.infoDialog.dialog = true;
        return;
      }

      let params = {
        startDtime: args.startTime,
        endDtime: args.endTime,
        roomIds: [],
        roomType: 'video', // room.type,
        timeZone: moment.tz.guess(),
      };
      params.roomIds.push(room._id);

      let startDtime = args.startTime;
      if (startDtime <= new Date()) {
        let endDtime = args.endTime;
        if (endDtime <= new Date()) {
          args.cancel = true;
          Util.snackBarOpen(this.$t('page.schedules.msg.overtime'), 'pink');
          return;
        }
        let interval = this.$store.state.settings.meetings.calendarInterval / this.$store.state.settings.meetings.calendarSlotCnt;
        params.startDtime = Util.nearestFutureMinutes(interval, moment());
        params.endDtime = params.startDtime.clone().add(interval, 'minutes');
      }

      if (!scheduleObj.isSlotAvailable(params.startDtime, params.endDtime, args.groupIndex)) {
        Util.snackBarOpen(this.$t('page.schedules.msg.reserved'), 'pink');
        args.cancel = true;
        return;
      } else {
        let reservedMeetings = (await this.$http.get(`/api/v1/meetings/duplicate`, {
          params: {
            startDtime: new Date(params.startDtime),
            endDtime: new Date(params.endDtime),
            // type: 'room',
            roomId: room._id
          }
        })).data;

        if (reservedMeetings.length > 0) {
          Util.snackBarOpen(this.$t('page.schedules.msg.reserved'), 'pink');
          args.cancel = true;
          return;
        }
      }
      if (room.isApprove) {
        this.approveCheckParams = params;
      } else {
        this.$router.push({ name: 'Reserve', query: { meetingInfo: JSON.stringify(params) }});
      }
      args.cancel = true;
    },
    onEventClick: function (args) {
      let event = args.event;
      // this.quickInfo.clickedEventInfo = event;
      // let x = args.originalEvent.clientX;
      // let y = args.originalEvent.clientY;
      // let overflowX = moment(event.endDtime).hour() > 17 ? 300 : 0;
      // let offsetX = Number(document.getElementById('appDrawer').style.width.replace('px', ''));
      // let offsetY = Number(document.getElementsByClassName('v-toolbar__content')[0].style.height.replace('px', ''));
      // this.quickInfo.clickedEventQuickInfoStyle.left = (x - offsetX - overflowX) + 'px';
      // this.quickInfo.clickedEventQuickInfoStyle.top = (y - offsetY) + 'px';

      let startDtime = new Date(event.startDtime);
      if (startDtime <= new Date()) {
        let endDtime = new Date(event.endDtime);
        if (endDtime <= new Date()) {
          args.event['IsReadonly'] = true;
          Util.snackBarOpen(this.$t('page.schedules.msg.end'), 'pink');
        } else {
          if (event.creator.email !== this.$store.state.user.email) {
            args.event['IsReadonly'] = true;
            Util.snackBarOpen(this.$t('page.schedules.msg.not-modify'), 'pink');
          }
        }
        return;
      }
      if (event.creator.email !== this.$store.state.user.email) {
        args.event['IsReadonly'] = true;
        return;
      }
      // this.$router.push({ name: 'Reserve', query: { meetingInfo: JSON.stringify(event) }});
      // args.cancel = true;
    },
    onPopupOpen: function (args) {
      let data = args.data;
      if (args.type === 'Editor' || args.type === 'RecurrenceAlert') {
        data = args.type === 'Editor' ? data : data.event;
        args.cancel = true;
        if (moment() >= moment(data.startDtime)) {
          Util.snackBarOpen(this.$t('page.schedules.msg.not-modify'), 'pink');
          return;
        }
        if (data.creator.email !== this.$store.state.user.email) {
          return;
        }
        if (args.type === 'RecurrenceAlert') {
          let scheduleObj = this.$refs.scheduleObj.ej2Instances;
          if (scheduleObj.currentAction === 'EditOccurrence') {
            this.$router.push({ name: 'Reserve', query: { meetingId: data._id }});
          } else {
            this.selectedMeeting = data.event;
            this.warning.dialog = true;
            return;
          }
        } else {
          this.$router.push({ name: 'Reserve', query: { meetingId: data._id }});
        }
        return;
      } else if (args.type === 'DeleteAlert') {
        args.cancel = true;
        this.selectedMeeting = data.event;
        this.warning.dialog = true;
        return;
      }
      // if (args.type === 'QuickInfo' || args.type === 'Editor' || args.type === 'RecurrenceAlert' || args.type === 'DeleteAlert') {
      //   let target = (args.type === 'RecurrenceAlert' ||
      //     args.type === 'DeleteAlert') ? data.element[0] : args.target;
      //   if (!isNullOrUndefined(target) && target.classList.contains('e-work-cells')) {
      //     let scheduleObj = this.$refs.scheduleObj;
      //     if ((target.classList.contains('e-read-only-cells')) ||
      //       (!scheduleObj.isSlotAvailable(data.endTime, data.endTime, data.groupIndex))) {
      //       args.cancel = true;
      //     }
      //   } else if (!isNullOrUndefined(target) && target.classList.contains('e-appointment') &&
      //     (this.isReadOnly(data.EndTime))) {
      //     args.cancel = true;
      //   }
      // }
    },
    onRenderCell: function (args) {
      if (args.element.classList.contains('e-work-cells')) {
        if (args.date < Date.now()) {
          args.element.setAttribute('aria-readonly', 'true');
          args.element.classList.add('e-read-only-cells');
        }

        // let addMinutes = Number(this.timeScale.interval / this.timeScale.slotCount);
        // let start = moment(args.date);
        // let end = moment(args.date).add(addMinutes, 'minutes');
        // if (start <= moment() && end > moment()) {
        //   args.element.style.backgroundColor = 'rgba(255, 0, 127, 0.08)';
        //   // args.element.classList.add('now-time-line');
        //   // console.log(args.element.classList);
        // }
        let interval = this.$store.state.settings.meetings.calendarInterval / this.$store.state.settings.meetings.calendarSlotCnt;
        let start = moment(args.date).format('YYYY-MM-DD HH:mm');
        let nearestStartTime = Util.nearestFutureMinutes(interval, moment()).format('YYYY-MM-DD HH:mm');
        if (start === nearestStartTime) {
          args.element.style.backgroundColor = 'rgba(255, 0, 127, 0.08)';
        }
      }
      if (args.elementType === 'emptyCells' && args.element.classList.contains('e-resource-left-td')) {
        let target = args.element.querySelector('.e-resource-text');
        target.innerHTML = `
          <div class="room-name" style="text-align: center; flex: 0 0 70% !important; -ms-flex: 0 0 70% !important;">${this.$t('page.daily-meeting.room-name')}</div>
          <div class="room-type" style="text-align: center; flex: 0 0 30% !important; -ms-flex: 0 0 30% !important;">${this.$t('page.daily-meeting.room-capacity')}(승인)</div>
        `;
      }
    },
    onEventRendered: function (args) {
      // let status = args.data.status;
      // if (status === 'e') {
      //   (args.element).style.backgroundColor = '#8C8C8C';
      // } else if (status === 's') {
      //   (args.element).style.backgroundColor = '#5587ED';
      // } else {
      //   if (args.data.type === 'video') {
      //     (args.element).style.backgroundColor = Util.calendarColors.video; // '#F361A6';
      //   } else {
      //     (args.element).style.backgroundColor = Util.calendarColors.room; // '#59DA50';
      //   }
      // }

      // if (!isNullOrUndefined(args.data.recurrenceRule)) {
      //   let meetingStart = moment(args.data.startDtime);
      //   let now = moment();
      //   if (now < meetingStart) {
      //     if (args.data.type === 'video') {
      //       (args.element).style.backgroundColor = Util.calendarColors.video; // '#F361A6';
      //     } else {
      //       (args.element).style.backgroundColor = Util.calendarColors.room; // '#59DA50';
      //     }
      //   }
      // }


      let backgroundColor = this.eventTypes.find(x => x.key === 'e').color;

      let status = args.data.status;
      let creatorEmail = args.data.creator.email;
      let isApprove = args.data.roomInfo.isApprove;
      let approveStatus = args.data.roomInfo.approveStatus;

      if (creatorEmail === this.$store.state.user.email) {
        if (status === 'e') {
          (args.element).style.backgroundColor = this.eventTypes.find(x => x.key === status).color;
        } else {
          if (isApprove) {
            if (approveStatus === 'waiting') {
              (args.element).style.backgroundColor = this.eventTypes.find(x => x.key === 'meQ').color;  
            } else {
              (args.element).style.backgroundColor = this.eventTypes.find(x => x.key === 'me').color;
            }
          } else {
            (args.element).style.backgroundColor = this.eventTypes.find(x => x.key === 'me').color;
          }
        }
      } else {
        if (isApprove && approveStatus === 'waiting') {
          status = 'q';
        }
        let tempStatus = status === 's' ? 'r' : status;
        (args.element).style.backgroundColor = this.eventTypes.find(x => x.key === status).color;
      }
      // if (status === 'e') {
      //   (args.element).style.backgroundColor = '#8C8C8C';
      // } else {
      //   (args.element).style.backgroundColor = args.data.color === undefined ? '#8C8C8C' : args.data.color;
      // }

      if (this.isReadOnly(args.data.endDtime)) {
        args.element.setAttribute('aria-readonly', 'true');
        args.element.classList.add('e-read-only');
      }
    },
    onActionBegin: function (args) {
      if (args.requestType === 'eventCreate' || args.requestType === 'eventChange') {
        let data;
        let scheduleObj = this.$refs.scheduleObj;
        if (args.requestType === 'eventCreate') {
          data = args.data[0];
        } else if (args.requestType === 'eventChange') {
          data = args.data;
        }
        let groupIndex = scheduleObj.ej2Instances.eventBase.getGroupIndexFromEvent(data);
        if (!scheduleObj.isSlotAvailable(data.StartTime, data.EndTime, groupIndex)) {
          args.cancel = true;
        }
      } else {
        // Event remove
      }
    },
    onActionComplete (args) {
      if (!this.isUseDataManager) {
        if (args.requestType === 'dateNavigate' || args.requestType === 'viewNavigate') {
          this.refreshMeetings();
        }
      }
      // console.log(scheduleObj.ej2Intances.selectedDate);
    },
    refreshMeetings () {
      let scheduleObj = this.$refs.scheduleObj;
      // if (scheduleObj === undefined || scheduleObj.ej2Instances === undefined || scheduleObj.ej2Instances === null) return;
      // let currentView = scheduleObj.ej2Instances.currentView;
      let selectedDate = moment(scheduleObj.ej2Instances.selectedDate).set({ hour: 0, minutes: 0, seconds: 0 });
      let startDate = selectedDate.startOf('day').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      let endDate = selectedDate.endOf('day').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      // if (currentView.indexOf('Day') > -1) {
      //   startDate = selectedDate.startOf('day').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      //   endDate = selectedDate.endOf('day').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      // } else if (currentView.indexOf('Week') > -1) {
      //   startDate = selectedDate.startOf('week').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      //   endDate = selectedDate.endOf('week').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      // } else {
      //   startDate = selectedDate.startOf('month').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      //   endDate = selectedDate.endOf('month').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      // }
      this.getMeetings(startDate, endDate, this.filter.buildingId === '9999' ? this.$store.state.user.location : this.filter.buildingId);
    },
    onDataBound (args) {
      // this.moveToScroll();
      // if (this.$route.query.reservedDate && !this.changeFlag) {
      //   let reservedDate = this.$route.query.reservedDate.replace('T', ' ').replace('Z', ' ').trim();
      //   let thisTimeDate = moment.tz(reservedDate, moment.tz.guess());
      //   let startDate = thisTimeDate.startOf('day').clone().utc().format('YYYY-MM-DDTHH:mm:ssZ');
      //   this.$refs.scheduleObj.changeDate(new Date(startDate));
      //   this.changeFlag = true;
      // }
    },
    // onDataBinding: function (args) {
    //   console.log('ondatabinding');
    //   let self = this;
    //   document
    //     .querySelector('.e-resource-column-wrap')
    //     .addEventListener('click', function (arg) {
    //       let roomName = arg.target.innerText;
    //       let className = arg.target.className;
    //       if (className === 'room-name') {
    //         let index = self.rooms.findIndex(room => room.name === roomName);
    //         if (index > -1) {
    //           self.roomDetail.selectedRoom = self.rooms[index];
    //           self.roomDetail.dialog = true;
    //         }
    //       }
    //     });
    //   if (this.isFirstDataBinding) {
    //     this.isFirstDataBinding = false;
    //   } else {
    //     this.moveToScroll();
    //   }
    // },
    onCellDoubleClick: function (args) {
      args.cancel = true;
      return;
    },
    async closeRoomDetailDialog (val) {
      this.roomDetail.dialog = false;
    },
    async closeWarningDialog (val) {
      if (val === 'ok') {
        let params = { actionUsr: this.$store.state.user.email, meetingKey: this.selectedMeeting.meetingKey, creator: this.selectedMeeting.creator };
        await this.$http.delete(`/api/v1/meetings/${this.selectedMeeting._id}`, { params: JSON.stringify(params) }).then(response => {
          this.warning.dialog = false;
          Util.snackBarOpen(this.$t('page.schedules.msg.delete-meeting'), 'pink');
          this.refreshMeetings();
        }).catch(error => {
          console.log(error);
          this.warning.dialog = false;
        });
      } else {
        this.warning.dialog = false;
      }
    },
    async closeInfoDialog (val) {
      this.infoDialog.dialog = false;
      if (val === 'reserveCheck') {
        this.clearSelectedCells();
      } else if (val === 'approveCheck') {
        if (this.approveCheckParams === null) return;
        this.$router.push({ name: 'Reserve', query: { meetingInfo: JSON.stringify(this.approveCheckParams) }});
      }
    },
    groupChange: function (value, buildingValue, floorValue) {
      this.filter.groupId = value;
      this.filter.buildingId = buildingValue;
      this.filter.floor = floorValue ? floorValue : '9999';
      this.pagination.selectedPage = 1;
      if (value === '9999') {
        this.getRooms(value, buildingValue, this.filter.floor, this.pagination.limit, this.pagination.skip);
      } else {
        this.getRooms(value, buildingValue, this.filter.floor, this.pagination.limit, this.pagination.skip);
        // this.meetingRoomDataSource = this.getMeetingRooms(this.pagination.limit, this.pagination.skip, value, buildingValue);
      }
    },
    buildingChange: function (value) {
      this.filter.buildingId = value;
      this.filter.floor = '9999';
      this.pagination.selectedPage = 1;
      if (value === '9999') {
        this.getRooms(this.filter.groupId, value, this.filter.floor, this.pagination.limit, this.pagination.skip);
        // this.meetingRoomDataSource = this.getMeetingRooms(this.pagination.limit, this.pagination.skip, this.filter.groupId);
      } else {
        this.getRooms(this.filter.groupId, value, this.filter.floor, this.pagination.limit, this.pagination.skip);
        // this.meetingRoomDataSource = this.getMeetingRooms(this.pagination.limit, this.pagination.skip, this.filter.groupId, value);
      }
    },
    moveToScroll () {
      // 시간 스크롤 옮기기
      let scheduleObj = this.$refs.scheduleObj;
      scheduleObj.scrollTo(moment().hour() + ':00');
    },
    async save () {
      console.log('## save ##');
      console.log(this.info);
      if (this.info.company === undefined || this.info.location === undefined) {
        this.error = 'Please fill in all the required fields.';
        return;
      }

      let userInfo = {
        _id: this.$store.state.user._id,
        company: this.info.company,
        location: this.info.location,
      };
      await this.$http.put('/api/v1/users/data/init', userInfo).then(response => {
        const result = response.data;
        if (result.data === 'ok') {
          let updateInfo = result.result;
          updateInfo.company = userInfo.company;
          updateInfo.location = userInfo.location;
          this.$store.dispatch('updateUser', updateInfo);
          Util.snackBarOpen(this.$t('page.profile.edit-profile-complete'), 'green');
          this.isNotInfo = false;
          this.changedGroupId = userInfo.company;
          window.location.reload();
        }
      }).catch(error => {
        console.log(error);
        Util.snackBarOpen('User Information Update error', 'error');
        this.isNotInfo = false;
      });
    },
    clearSelectedCells () {
      let scheduleObj = this.$refs.scheduleObj;
      let selectedCells = scheduleObj.ej2Instances.element.querySelectorAll('.e-selected-cell');
      for (let i = 0; i < selectedCells.length; i++) {
        selectedCells[i].classList.remove('e-selected-cell');
      }
    }
    // eventEdit () {
    //   this.$router.push({ name: 'Reserve', query: { meetingInfo: JSON.stringify(this.quickInfo.clickedEventInfo) }});
    //   this.quickInfo.clickedEventInfo = undefined;
    // },
    // eventDelete () {
    //   this.selectedMeeting = this.quickInfo.clickedEventInfo;
    //   this.warning.dialog = true;
    //   this.quickInfo.clickedEventInfo = undefined;
    // },
    // eventClose () {
    //   this.quickInfo.clickedEventInfo = undefined;
    // }
  }
};

</script>
<style lang="stylus">
  @import '../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  // @import '../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  // @import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
</style>



// WEBPACK FOOTER //
// src/pages/Meeting.vue